import {
  TopToolbar,
  ExportButton,
  List,
  DatagridConfigurable,
  SelectColumnsButton,
  TextField,
  DateField,
  Filter,
  SearchInput,
  FilterButton,
  FilterForm,
  TextInput,
  usePermissions,
  DateTimeInput,
} from "react-admin";
import { Stack } from "@mui/material";
import UserNameHyperlink from "../components/react-admin/UserNameHyperlink";


const ReferralRecords = (props: object) => {
  const { permissions } = usePermissions();
  const transactionFilters = [
    <DateTimeInput source="startDate" alwaysOn />,
    <DateTimeInput source="endDate" alwaysOn />,
    <TextInput label="Filter By Referral Code" source="referralCode" />,
  ];
  const ListToolbar = () => (
    <Stack direction="row">
      <FilterForm filters={transactionFilters} />
    </Stack>
  );

  const UserNameFilter = (props: any) => (
    <Filter {...props}>
      <SearchInput
        placeholder="Search UserName"
        source="userName"
        resettable
        alwaysOn
      />

      <SearchInput
        placeholder="Search Referred UserId"
        source="referredUserName"
        resettable
        alwaysOn
      />
    </Filter>
  );
  const ListActions = () => (
    <TopToolbar>
      <FilterButton filters={transactionFilters} />
      <SelectColumnsButton />
      {permissions.includes("admin") && <ExportButton />}
    </TopToolbar>
  );
  
  return (
    <>
      <List
        {...props}
        sort={{ field: "createdAt", order: "DESC" }}
        actions={<ListActions />}
        filters={<UserNameFilter />}
      >
        <ListToolbar />
        <DatagridConfigurable bulkActionButtons={false}>
          <TextField source="referralCode" label="Referral Code" />
          <UserNameHyperlink label="User Name" source="userName" to="userId" />
          <TextField source="referredUserName" label="Referred Username"/>
          <TextField source="totalMatches" label="Total Matches"/>
          <TextField source="amount" />
          <DateField source="createdAt" showTime />        
        </DatagridConfigurable>
      </List>
    </>
  );
};

export default ReferralRecords;
